import {FC} from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import lengthicon from '../assets/images/icons/pass-24.svg';
import digiticon from '../assets/images/icons/numeric-24.svg';
import caseicon from '../assets/images/icons/capital-24.svg';
import { PasswordStrengthProps } from "../interfaces";


const useStyles = makeStyles((theme) => ({
    errorcolor:{
        '& .MuiTypography-colorSecondary':{
            color: "#cd2d27"
        },
        '& p':{
            marginBottom: '20px',
            '& img':{
                marginRight: '12px',
            },
            '&.MuiTypography-colorPrimary':{
                '& img':{
                    marginRight: '12px',
                    filter: 'invert(78%) sepia(61%) saturate(728%) hue-rotate(102deg) brightness(99%) contrast(73%)'
                }
            }
        },
      
    }
  }));



const Numeric = () => {
    return (
        <img src={digiticon} className="valign-middle" alt="numeric" />
    )
}
const Length = () => {
    return (
        <img src={lengthicon} className="valign-middle" alt="numeric" />
    )
}
const Capital = () => {
    return (
        <img src={caseicon} className="valign-middle" alt="case" />
    )
}

const PasswordStrengthIndicator:FC<PasswordStrengthProps> = ({
    validity: { minChar, number, lowerUpper, invalidText, specialCharacter }
}) => {
    
    return (
        <div>
            <PasswordStrengthIndicatorItem
                isValid={minChar}
                text="Check a password between 8 to 36 characters"
                img={<Length />}             
            />
            <PasswordStrengthIndicatorItem
                isValid={number}
                text="At least one numeric digit"
                img={<Numeric />}
            />
            <PasswordStrengthIndicatorItem
                isValid={lowerUpper}
                text="One uppercase and lowercase letter"
                img={<Capital />}

            />
            <PasswordStrengthIndicatorItem
                isValid={invalidText}
                text="Password cannot include the string gains"
                img={<Length />}
            
            />
            <PasswordStrengthIndicatorItem
                isValid={specialCharacter}
                text="Password must contain a special character"
                img={<Length />}
            />
        </div>
    );
};

const PasswordStrengthIndicatorItem:FC<PasswordStrengthProps> = ({ isValid, text, img }) => {
    const classes = useStyles();
    const highlightClass = isValid
        ? "d-none"
        : isValid !== null
        ? "secondary"
        : "secondary";
    return(
        <div className={`${classes.errorcolor} ${highlightClass}`}>
            <Typography variant="subtitle1" component="p" color="secondary" className="fw-normal" >{img}{text}</Typography>
        </div>
    )
};

export default PasswordStrengthIndicator;